import i18n from '../../i18n/i18next'
import { defaultAddSnack } from '../../state/overlayState/overlayContext'
import { isDebugUser, Utils } from '../../utils'

export const logInterResponseError = async (error: any) => {
    Utils.pushLog({
        tags: ['HTTP', 'ERROR'],
        message: error.message,
        extraArgs: [error],
        timeStamp: Date.now(),
    })
    // TODO: Handle more error codes
    if (error.code === 'ECONNABORTED') {
        if (isDebugUser())
            defaultAddSnack(i18n.t('snack.networkError'), 'error', false)
    }

    return Promise.reject(error)
}
